import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import "../../styles/Home.css";
import rebranding_and_white_labling from "../../Assets/rebranding_and_white_labling.png";
import UploadingAndFormatting from "./uploadinfAndformating";
import Functions from "./functions";
import { try_for_free } from "../../url";
import features from "../../Assets/features.png";

// Shared styles for better consistency
const styles = {
  container: {
    maxWidth: { xs: "100%", sm: "90%", md: "85%", lg: "80%", xl: "75%" },
  },
  heading: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    fontSize: { xs: "3rem", md: "5rem" },
    color: "#1662A7",
    textShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  subHeading: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    fontSize: { xs: "1.8rem", md: "2.5rem" },
    color: "#1662A7",
    mb: 4,
    textAlign: "center",
  },
  textContent: {
    fontFamily: "Roboto",
    lineHeight: 1.7,
    fontWeight: "normal",
    fontSize: { xs: "1rem", md: "1.1rem" },
    color: "#6E6B7B",
    mb: 3,
  },
  button: {
    backgroundColor: "#25B2E8",
    fontFamily: "Roboto",
    height: "50px",
    fontWeight: "bold",
    borderRadius: "12px",
    fontSize: { xs: "0.9rem", md: "1.1rem" },
    color: "white",
    textTransform: "capitalize",
    px: { xs: 3, md: 4 },
    py: 1.5,
    "&:hover": {
      backgroundColor: "#1EA8D9",
      transform: "translateY(-2px)",
      boxShadow: "0px 8px 25px rgba(37, 178, 232, 0.3)",
    },
    transition: "all 0.3s ease",
  },
};

function Features() {
  return (
    <>
      {/* Hero Section */}
      <Box
        sx={{
          mt: { xs: 8, md: 10 },
          pt: { xs: 4, sm: 6, md: 8 },
          pb: { xs: 4, md: 6 },
          backgroundImage: `linear-gradient(rgba(22, 98, 167, 0.1), rgba(37, 178, 232, 0.05)), url(${features})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: { xs: "30vh", md: "15vh" },
        }}
      >
        <Container maxWidth="lg" sx={styles.container}>
          <Box textAlign="center">
            <Typography variant="h1" sx={styles.heading}>
              Features
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Rebranding & White Labeling Section */}
      <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#F8F8F8" }}>
        <Container maxWidth="lg" sx={styles.container}>
          <Typography variant="h2" sx={styles.subHeading}>
            Rebranding & White Labeling
          </Typography>

          <Grid container spacing={6} alignItems="center">
            {/* Image */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: { xs: 4, md: 0 },
                }}
              >
                <Box
                  component="img"
                  src={rebranding_and_white_labling}
                  alt="Rebranding & White Labeling"
                  sx={{
                    width: "95%",
                    maxWidth: "500px",
                    borderRadius: "15px",
                    boxShadow: "0px 8px 40px rgba(0, 0, 0, 0.15)",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                />
              </Box>
            </Grid>

            {/* Content */}
            <Grid item xs={12} md={6}>
              <Stack spacing={3} sx={{ px: { xs: 2, md: 3 } }}>
                <Typography variant="body1" sx={styles.textContent}>
                  Tailor your experience with our Rebranding & White Labeling
                  features. Professional and Team plans offer logo
                  customization, while Enterprise and On-Prem take it to the
                  next level with custom domain names.
                </Typography>

                <Box
                  sx={{
                    p: 3,
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6E6B7B",
                      mb: 1,
                      fontSize: "0.9rem",
                    }}
                  >
                    Example of custom domain:
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#1662A7",
                      fontSize: { xs: "1.1rem", md: "1.2rem" },
                      fontFamily: "monospace",
                    }}
                  >
                    esign.YourCompany.com
                  </Typography>
                </Box>

                <Box sx={{ pt: 2 }}>
                  <Button
                    component="a"
                    href={try_for_free}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={styles.button}
                  >
                    Try for FREE
                  </Button>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Additional Components */}
      <UploadingAndFormatting />
      <Functions />
    </>
  );
}

export default Features;
